import React from 'react';

// Estilos globales (titulo_solicitud, .row, btn_solicitud…) que todavía usan otras vistas
import "./SolicitudInscripcion.css"

import VistaSolicitudes from '../../Compartidas/VistaSolicitudes';

import inscripcionesDataHelper from '../../../Helpers/InscripcionData';
import { LICENCIATURAS_INSCRIPCION } from '../../../Helpers/solicitudes';

const SolicitudInscripcion = () => (
    <VistaSolicitudes
        helper={inscripcionesDataHelper}
        encabezado='Solicitudes de inscripción'
        licenciaturas={LICENCIATURAS_INSCRIPCION}
        rutaDetalle='/solicitud-inscripcion/'
    />
);

export default SolicitudInscripcion;
